import { combineReducers } from "redux";
import {
  _FAILURE,
  _SUCCESS,
  FETCH_DOCTOR_DOCUMENTS_REQUEST,
  ADD_DOCTOR_DOCUMENT_REQUEST,
  DELETE_DOCTOR_DOCUMENT_REQUEST,
} from "./constants";
import { Action } from "./types";
import { DoctorDocument } from "../types";

const initialState: DoctorDocument[] = [];

function items(state = initialState, action: Action): DoctorDocument[] {
  let newState = null;
  switch (action.type) {
    case FETCH_DOCTOR_DOCUMENTS_REQUEST + _SUCCESS:
      return action.payload;

    case ADD_DOCTOR_DOCUMENT_REQUEST + _SUCCESS:
      return [...state, action.payload];

    case DELETE_DOCTOR_DOCUMENT_REQUEST + _SUCCESS:
      newState = state?.filter((doc) => doc.id !== action.data.documentId);
      return newState;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action) {
  switch (action.type) {
    case FETCH_DOCTOR_DOCUMENTS_REQUEST:
      return true;

    case FETCH_DOCTOR_DOCUMENTS_REQUEST + _SUCCESS:
    case FETCH_DOCTOR_DOCUMENTS_REQUEST + _FAILURE:
      return false;

    default:
      return state;
  }
}

export const doctorDocuments = combineReducers({ items, isFetching });
